import { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import DisplayGroupForm, { DisplayGroupFormRef } from "@/components/admin/displayGroup/DisplayGroupForm";
import PageHeader from "@/components/admin/header/PageHeader";
import SubmitAndCancelButtons from "@/components/admin/SubmitAndCancelButtons";
import { routes } from "@/configs/router.config/routes";
import { useDisplayGroups } from "@/hooks/useDisplayGroups";
import { useLandingPaths } from "@/hooks/useLandingPaths";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { DisplayGroupService } from "@/services/displayGroup/displayGroup.service";
import { showError, showSuccess } from "@/utils/notification";

const DisplayGroupCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { isLoading: isLoadingDisplayGroup, mutate: mutateDisplayGroups } = useDisplayGroups();
  const { landingPaths, isLoading: isLoadingLandingPaths, mutate: mutateLandingPaths } = useLandingPaths();
  const [isCreatingDisplayGroup, setIsCreatingDisplayGroup] = useState(false);
  const formRef = useRef<DisplayGroupFormRef>(null);

  const initialName = searchParams.get("name") || "";

  const isLoading = isLoadingDisplayGroup || isLoadingLandingPaths || isCreatingDisplayGroup;

  const handleUpdateDisplayGroup = async (name: string, paths: string[]) => {
    try {
      setIsCreatingDisplayGroup(true);
      await DisplayGroupService.create(name, paths, sessionCurrentWorkspaceId);
      await Promise.all([mutateDisplayGroups(), mutateLandingPaths()]);
      setIsCreatingDisplayGroup(false);
      showSuccess("表示グループを作成しました。");
      navigate(routes.displayGroup(sessionCurrentWorkspaceId));
    } catch (error) {
      console.error(error);
      showError("表示グループの作成に失敗しました。");
    }
  };

  return (
    <div className="flex flex-col overflow-hidden">
      <div className="flex justify-between items-center">
        <PageHeader hasBack title="表示グループ作成" />
        {/* 右上のボタン */}
        <SubmitAndCancelButtons
          isLoading={isLoading}
          onCancel={() => navigate(routes.displayGroup(sessionCurrentWorkspaceId))}
          onSubmit={() => formRef.current?.triggerSubmit()}
          buttonClassName="min-w-40"
        />
      </div>

      {landingPaths
        ? (
          <DisplayGroupForm
            ref={formRef}
            submit={handleUpdateDisplayGroup}
            landingPaths={landingPaths}
            initialName={initialName}
          />
        )
        : null}
    </div>
  );
};

export default DisplayGroupCreatePage;
